import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { Model } from 'src/app/shared/models/clux/model-legacy';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatSuffix } from '@angular/material/input';
import { VideosComponent } from '../videos/videos.component';

@Component({
  selector: 'app-play-videos',
  templateUrl: './play-videos.component.html',
  styleUrls: ['./play-videos.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatDialogTitle, MatIconButton, MatIcon, MatSuffix, VideosComponent],
})
export class PlayVideosComponent {
  public data = inject<Model.MatDialogModel>(MAT_DIALOG_DATA);
  private modalRef = inject<MatDialogRef<PlayVideosComponent>>(MatDialogRef);

  public videoClosed: boolean = false;
  public autoPlay: boolean = true;

  public close(): void {
    this.videoClosed = !this.videoClosed;
    this.modalRef.close();
  }
}
